
import {
  DevFunction, ObjectObject, verifyTypes, getString, RuntimeError,
} from "../../../interpreting/ScriptInterpreter.js";
import {
  DOMNodeObject, clearAttributes, validateJSXInstance, CLASS_NAME_REGEX,
} from "../jsx_components.js";
import {getID} from "./getID.js";


export const render = new DevFunction(
  "InputCheckbox.render", {typeArr: ["object?"]},
  function(
    {callerNode, execEnv, interpreter, thisVal},
    [props = {}]
  ) {
    validateJSXInstance(thisVal, "InputCheckbox", callerNode, execEnv);
    if (props instanceof ObjectObject) {
      props = props.members;
    }
    let {className, idKey, checked, onChange, onInput} = props;
    verifyTypes(
      [onChange, onInput], ["function?", "function?"],
      callerNode, execEnv
    );
    let id = idKey === undefined ? undefined : getID(idKey);

    // Create the DOM node if it has no been so already.
    let jsxInstance = thisVal.jsxInstance;
    let domNode = jsxInstance.domNode;
    if (!domNode || domNode.tagName !== "INPUT") {
      domNode = document.createElement("input");
      if (checked) domNode.setAttribute("checked", true);
    }
    else {
      clearAttributes(domNode, ["type", "checked"]);
    }
    if (className) {
      className = getString(className, callerNode, execEnv);
      if (!CLASS_NAME_REGEX.test(className)) throw new RuntimeError(
        `Invalid class name: "${className}"`,
        callerNode, execEnv
      );
      domNode.setAttribute("class", className);
    }
    domNode.setAttribute("type", "checkbox");
    domNode.setAttribute("class", "input-checkbox");
    if (id !== undefined) domNode.setAttribute("id", id);

    // Set the onchange event if props.onChange is supplied.
    if (onChange) {
      domNode.onchange = (event) => {
        let {checked} = event.target;
        let e = {value: checked};
        interpreter.executeFunctionOffSync(
          onChange, [e], callerNode, execEnv, thisVal
        );
      };
    }

    // Set the oninput event if props.onInput is supplied.
    if (onInput) {
      domNode.oninput = (event) => {
        let {checked} = event.target;
        let e = {value: checked};
        interpreter.executeFunctionOffSync(
          onInput, [e], callerNode, execEnv, thisVal
        );
      };
    }

    return new DOMNodeObject(domNode);
  }
);


export const methods = [
  "getIsChecked",
  "setIsChecked",
  "clear",
  "focus",
  "blur",
];

export const actions = {
  "getIsChecked": new DevFunction(
    "getIsChecked", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputCheckbox", callerNode, execEnv);
      return thisVal.jsxInstance.domNode.checked;
    }
  ),
  "setIsChecked": new DevFunction(
    "setIsChecked", {}, function({thisVal, callerNode, execEnv}, [val]) {
      validateJSXInstance(thisVal, "InputCheckbox", callerNode, execEnv);
      val = val ? true : false;
      let {domNode} = thisVal.jsxInstance;
      domNode.checked = val;
    }
  ),
  "clear": new DevFunction(
    "clear", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputCheckbox", callerNode, execEnv);
      let {domNode, props} = thisVal.jsxInstance;
      let {checked: initVal} = props;
      domNode.checked = initVal ? true : false;
    }
  ),
  "focus": new DevFunction(
    "focus", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputCheckbox", callerNode, execEnv);
      let {jsxInstance} = thisVal;
      if (jsxInstance.canGrabFocus()) {
        thisVal.jsxInstance.domNode.focus();
        return true;
      }
      else {
        return false;
      }
    }
  ),
  "blur": new DevFunction(
    "blur", {}, function({thisVal, callerNode, execEnv}, []) {
      validateJSXInstance(thisVal, "InputCheckbox", callerNode, execEnv);
      thisVal.jsxInstance.domNode.blur();
    }
  ),
};